<div class="warp-btn">
    <div class="load-save" *ngIf="loadingSave$()">
        <img class="load-img" src="/assets/images/loading/save-loading.svg">
    </div>
    <div class="warp-save-btn">
        <div class="btn white flex-direction-revers-by-dir-he" (click)="saveAnswer()">
            <div class="text" translate>
                btns.temporarySave
            </div>
            <img class="scale-img " src="/assets/images/save-dark.svg">

        </div>
    </div>
    <div class="btn white pdf" (click)="downloadPdf()">
        <img src="/assets/images/export/download.svg">
    </div>
    <!-- [ngClass]="{'disable':!validCurrentStep$()}" -->
    <!-- valid:{{CorrectAllQuestion$()}}
    second var:{{notValidCurrentQuestionnaire$()}} -->
    <div class="btn main flex-direction-revers-by-dir-he"
        (click)="validCurrentQuestionnaire$()?(notValidCurrentQuestionnaire$() ?showErrors(statusValidation.NotValid) :sendAnswer()):showErrors(statusValidation.Error)">
        <div class="text" translate>btns.send
        </div>
        <img src="/assets/images/publish.svg" />
    </div>

</div>